import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'

interface PayLinkOptions {
  amount: number
}

/**
 * Controller class for the pay link limit modal component
 *
 * @class PayLinkLimitModalController
 */
export class PayLinkLimitModalController {
  public readonly close: () => void
  public amount: number
  private readonly internalClose: (val: IPromise<boolean>) => void

  constructor(
    $scope: IScope,
    close: () => void,
    public options: PayLinkOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'

    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.amount = options.amount

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
